export default __webpack_public_path__ + "static/media/fink-vertical-mobile.daf762c5.png";